// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import * as Sentry from '@sentry/react';

// The inbox polls, so the same broken message comes back every thirty seconds.
// Reporting it once a session is enough to notice it and not enough to bury
// everything else in Sentry.
const reportedMessages = new Set<string>();

/**
 * Reports a message the screen cannot draw, once per message per session.
 *
 * A message is written with its templates and its context in one statement, so
 * one the screen cannot draw means the write path is broken. The reader sees
 * the message disappear rather than a row full of braces.
 */
export function reportUndrawableMessage(
  reason: string,
  messageKey: string,
  detail: unknown
) {
  if (reportedMessages.has(messageKey)) {
    return;
  }
  reportedMessages.add(messageKey);

  if (import.meta.env.MODE === 'development') {
    console.error(reason, messageKey, detail);
  }
  Sentry.captureException(Error(reason, { cause: detail }), {
    extra: { messageKey, detail },
  });
}
